import { CLASS_NAME_OF_BETTING_COMPONENTS } from 'app-constants';

export default function createPortalNode(): HTMLElement {
    const el = document.createElement('aside');
    el.classList.add(CLASS_NAME_OF_BETTING_COMPONENTS);

    return el;
}
